/**
 * Projet: Gestion des stagiaires
 * Auteur : Tim Allemann
 * Date : 07.10.2022
 * Description : Configurations des requêtes API pour les types d'ARE
 * Fichier : typeJobSearchAssistanceOccurrencesService.js
 **/

import axios from 'axios'

const API_URL = process.env.VUE_APP_API_URL
const CONTROLLER = '/api/typeJobSearchAssistanceOccurrences'

export default {
  getTypeJobSearchAssistanceOccurrences() {
    return axios.get(API_URL + CONTROLLER)
  },
  getTypeJobSearchAssistanceOccurrence(id) {
    return axios.get(API_URL + CONTROLLER + '/' + id)
  },
  postTypeJobSearchAssistanceOccurrence(typeJobSearchAssistanceOccurrence) {
    return axios.post(API_URL + CONTROLLER, typeJobSearchAssistanceOccurrence)
  },
  putTypeJobSearchAssistanceOccurrence(typeJobSearchAssistanceOccurrence) {
    return axios.put(
      API_URL +
        CONTROLLER +
        '/' +
        typeJobSearchAssistanceOccurrence.typeJobSearchAssistanceOccurrenceId,
      typeJobSearchAssistanceOccurrence
    )
  },
  deleteTypeJobSearchAssistanceOccurrence(typeJobSearchAssistanceOccurrenceId) {
    return axios.delete(
      API_URL + CONTROLLER + '/' + typeJobSearchAssistanceOccurrenceId
    )
  }
}
